exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".promo-cards{\r\n    color: #fff;\r\n}\r\n.card-header{\r\n    font-size: 66px;\r\n    text-align: left;\r\n    margin-bottom: -76px;\r\n\r\n}\r\n.header2 {\r\n    font-size: 28px; \r\n}\r\n\r\n.content h5{\r\n    padding-top: 5px;\r\n    padding-bottom: 5px;\r\n    border-bottom: 1px solid #e2e2e2;\r\n}\r\n\r\n.shdw{\r\n    box-shadow: 0px 5px 6px 1px rgba(189,189,189,1);\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/PROJECTS/Sokousoni/winda-dashboard/dashboard-winda-mvp/src/app/home/home.component.css
// module id = ../../../../../src/app/home/home.component.css
// module chunks = main